export const ACORD_TRANSACTION_STATUSES = [
  'Quote', 'Issue Policy', 'Bound', 'Renew', 'Change', 'Cancel',
];

export const DEFAULT_TRANSACTION_STATUS = 'Renew';

export function shouldPopulateTargetCarrier(status, checkedLOBs) {
  return status === 'Renew' && checkedLOBs && checkedLOBs.size === 1;
}
